import { render, staticRenderFns } from "./screenshot-poster.vue?vue&type=template&id=ed93b934&scoped=true"
import script from "./screenshot-poster.vue?vue&type=script&lang=js"
export * from "./screenshot-poster.vue?vue&type=script&lang=js"
import style0 from "./screenshot-poster.vue?vue&type=style&index=0&id=ed93b934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed93b934",
  null
  
)

export default component.exports